import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { NotificationConfig, NotificationType } from './models';
import { combineLatest } from 'rxjs/internal/operators/combineLatest';

@Injectable({
  providedIn: 'root',
})
export class UiNotificationService {
  private readonly messageService = inject(MessageService);
  readonly CLOSE_TIME = 5000;

  showSuccess(title = 'Success', message = 'Operation successful.', config?: NotificationConfig): void {
    this.messageService.add({
      ...config,
      summary: title,
      detail: message,
      life: this.CLOSE_TIME,
      data: { ...config?.data, type: NotificationType.success },
    });
  }

  showError(title = 'Error', message = 'Some error happened. Please try again later.', config?: NotificationConfig): void {
    this.messageService.add({
      ...config,
      summary: title,
      detail: message,
      life: this.CLOSE_TIME,
      data: { ...config?.data, type: NotificationType.error },
    });
  }
}
